// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"297":"67c7ae5a","370":"6a9068a7","766":"52c827e4","899":"350d6dc0"}[chunkId] + ".js";
};